<template>
  <div class="page-dialog">
    <el-form
      label-width="80px"
      label-position="right"
      :inline="true"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="计划类型">
            <el-select
              v-model="conditions.zqdlx"
              placeholder="请选择"
            >
              <el-option
                v-for="item in selectDataOptions['goodsPlanType']"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经销商">
            <el-input v-model="conditions.partnerName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计划年度">
            <el-input v-model="conditions.pyear" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计划月度">
            <el-select v-model="conditions.month">
              <el-option v-for="item in 12" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="存货分类">
            <el-select v-model="conditions.brand" disabled clearable>
              <el-option
                v-for="item in selectDataOptions['A0019']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tr">
        <el-button type="default" size="small" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="queryData">查询</el-button>
      </el-row>
    </el-form>

    <div class="table-container">
      <TableCommon
        :show-header="false"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        >
          <template #productId="{ row }">
            {{ filterDictionary(row.productId, 'A0019') }}
          </template>
          <template #brand="{row}">
            <el-select v-model="row.brand" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0019']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

  </div>
</template>

<script>
import { filterDictionary } from '@/utils/index'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindDeliverPlan } from '@/api/applyForGoods/embezzlePlan'

export default {
  props: {
    query: {
      type: Object,
      default: () => ({ partner: '', partnerName: '' })
    }
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      conditions: {
        month: '1',
        partner: '',
        partnerName: '',
        pyear: new Date().getFullYear().toString(),
        zqdlx: '',
        brand: ''
      },
      gridOptions: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 50 },
          { title: '经销商', field: 'partner' },
          { title: '存货分类', field: 'brand', slots: { default: 'brand' }},
          { title: '年度', field: 'pYear' },
          { title: '月度', field: 'month' },
          { title: '计划量', field: 'planQty' }
        ],
        data: []
      },
      selectDataOptions: {}
    }
  },
  created() {
    this.getSelectDictDataOrigin('goodsPlanType')
    this.getSelectDictDataOrigin('A0019')
    Object.assign(this.conditions, this.query)
  },
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    filterDictionary,
    resetQuery() {
      this.conditions = {
        month: '',
        partner: '',
        productId: '',
        pyear: '',
        zqdlx: ''
      }
    },
    async queryData() {
      const { data } = await apiFindDeliverPlan(this.conditions)
      if (data) {
        data.pYear = this.conditions.pyear
        data.month = this.conditions.month
        data.partner = this.conditions.partnerName
        data.brand = this.conditions.brand
        this.gridOptions.data = [data]
      }
    },
    async submitHandle() {
      const data = await this.$refs.ProductSelect.submitForm()
      if (data) {
        this.conditions.productId = data.productCode
      }
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    submitForm() {
      return Promise.resolve(this.$refs.gridOptions.getRadioRecord())
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialog/GoodsPlan.vue